<template>
  <div>
    <div v-if="allDataIsLoaded">
      <div v-if="openEnded">
        <SurveyQualificationOpenEnd
          :qualification="this.qualification"></SurveyQualificationOpenEnd>
      </div>
      <div v-else>
        <SurveyQualificationSinglePunch
          :qualification="this.qualification"></SurveyQualificationSinglePunch>
      </div>
    </div>
    <div v-else>
      <Loading></Loading>
    </div>
  </div>
</template>

<script>
    import {
        GET_BACKEND_URL,
        GET_HTTP_CONFIG,
        LOAD_SURVEY_QUALIFICATIONS,
        LOADING_COMPLETED_SUCCESS,
        R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
        R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_PAYMENT,
        R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION,
        SET_RESET_SELECTED_QUALIFICATIONS,
        SET_SURVEY_SELECTED_QUALIFICATIONS
    } from "../../services/constants"
    import SurveyQualificationOpenEnd from "./SurveyQualificationOpenEnd"
    import SurveyQualificationSinglePunch from "./SurveyQualificationSinglePunch"
    import http from "../../services/axios"

    export default {
        name: "SurveyQualificationQuestion",
        components: {SurveyQualificationSinglePunch, SurveyQualificationOpenEnd},
        created() {
            if (this.$store.state.dataModule.qualifications.loadingState === LOADING_COMPLETED_SUCCESS) {
                this.updateQualification()
            } else {
                if (this.$route.query.manage) {
                    this.$store.commit(SET_RESET_SELECTED_QUALIFICATIONS)
                    http.get(this.$store.getters[GET_BACKEND_URL](`studies/${this.$route.params.id}/lucid`), this.$store.getters[GET_HTTP_CONFIG])
                        .then(response => {
                            this.$store.commit(SET_SURVEY_SELECTED_QUALIFICATIONS, {"countryLanguageID": response.data.countryLanguageID})
                            return this.$store.dispatch(LOAD_SURVEY_QUALIFICATIONS, response.data.countryLanguageID)
                        })
                        .then(() => {
                            this.$router.push({
                                name: R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_PAYMENT,
                                query: this.$route.query,
                                params: {id: this.$route.params.id}
                            })
                        })
                } else if (this.$route.query.update) {
                    http.get(this.$store.getters[GET_BACKEND_URL](`studies/${this.$route.params.id}/lucid`), this.$store.getters[GET_HTTP_CONFIG])
                        .then(response => {
                            this.$store.commit(SET_SURVEY_SELECTED_QUALIFICATIONS, {"countryLanguageID": response.data.countryLanguageID})
                            return this.$store.dispatch(LOAD_SURVEY_QUALIFICATIONS, response.data.countryLanguageID)
                        })
                        .then(() => {
                            this.updateQualification()
                            this.$router.push({
                                name: R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION,
                                query: {
                                    update: true
                                },
                                params: {
                                    questionName: this.$store.state.dataModule.qualifications.data[0].name
                                }
                            })
                        })
                } else {
                    this.$router.push({
                        name: R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
                        query: this.$route.query
                    })
                }
            }
        },

        data() {
            return {
                qualification: {}
            }
        },

        computed: {
            openEnded() {
                return this.qualification.questionType === 'Numeric - Open-end'
            },
            allDataIsLoaded() {
                return this.qualificationsAreLoaded && this.qualificationHasBeenSet
            },
            qualificationsAreLoaded() {
                return this.$store.state.dataModule.qualifications.loadingState === LOADING_COMPLETED_SUCCESS
            },
            qualificationHasBeenSet() {
                return !(Object.entries(this.qualification).length === 0)
            }
        },

        methods: {
            updateQualification() {
                let questionName = this.$route.params.questionName
                let qualifications = this.$store.state.dataModule.qualifications.data
                for (let qual of qualifications) {
                    if (qual.name === questionName) {
                        this.qualification = qual
                    }
                }
            },
        },

        watch: {
            '$route'() {
                this.updateQualification()
            }
        },

    }
</script>

<style scoped>

</style>
